﻿import $ from "jquery";

var main = "#td-main";
var showSideClass = "td-showside";
var pinSideClass = "td-pinside";
var pinSideCookie = "td-sidebar";
var dbPathRegex = /^(.*\/db\/[-\d]+)\/.*/i;
var dbMode = dbPathRegex.test(location.pathname);

function initSidebar(options) {

	options = $.extend({
		showSidebarText: "Show Sidebar",
		hideSidebarText: "Hide Sidebar",
		pinSidebarText: "Pin Sidebar",
		unpinSidebarText: "Unpin Sidebar",
	}, options);


	function isPinned() {
		return $(main).hasClass(pinSideClass);
	}

	function toggleSidebar(show, noanimate) {
		var mel = $(main);
		var action = show != null ? show : !mel.hasClass(showSideClass);

		function endToggle() {
			var title = action ? options.hideSidebarText : options.showSidebarText;
			$("#td-showside").attr("title", title).find(".ui-icontext").text(title);
			if(!action) mel.removeClass(showSideClass);
			mel.css("left", "");
		}

		if(action) mel.addClass(showSideClass);

		if(!noanimate && !mel.hasClass("td-twocols") && !isPinned()) {
			var left = mel.css("margin-left").substring(1);
			if(action) mel.css("left", 0);
			mel.animate({ left: action ? left : 0 }, {
				progress: function () { $(window).trigger("scroll"); },
				complete: function () { endToggle(); $(window).trigger("scroll"); }
			});
		}
		else {
			endToggle();
			if(!noanimate)
				$(window).trigger("scroll").trigger("resize");
		}
	}

	function setPinned(action) {
		var title = action ? options.unpinSidebarText : options.pinSidebarText;
		$(main).toggleClass(pinSideClass, action);
		$("#td-pinside").toggleClass("ui-icon-pinned", action);
		$("#td-pinside").attr("title", title).find(".ui-icontext").text(title);
		$(window).trigger("resize");
	}

	function onToggleSidebar() {
		toggleSidebar();
		return false;
	}

	function onPinSidebar() {
		var action = !isPinned();
		if(dbMode)
			$.cookie(pinSideCookie, 0 | action, 3E8, location.pathname.replace(dbPathRegex, "$1"));
		setPinned(action);
		if(!action) toggleSidebar(false);
		return false;
	}

	$("<button id=\"td-showside\" class=\"ui-button ui-icon-nav ui-icon-only\"><i class=\"ui-icontext\"></i></button>")
	.prependTo("#td-menubtm").on("click", onToggleSidebar);
	$("<button id=\"td-pinside\" class=\"ui-button ui-icon-pin ui-icon-only\"><i class=\"ui-icontext\"></i></button>")
	.prependTo("#td-sidebar").on("click", onPinSidebar);

	var pinned = !dbMode || !window.matchMedia("screen and (max-width: 1279px)").matches && $.cookie(pinSideCookie) !== "0";
	toggleSidebar(pinned, true);
	setPinned(pinned);
	$(document.body).on("click", function(e) {
		if(!isPinned() && !$(e.target).closest(".ui-sidebar").length)
			toggleSidebar(false);
	});
}

export { initSidebar };

